<template>
  <div>
    <h4>Bild</h4>
    <b-card>
      <div style="overflow: hidden" class="pb-3">
        <img :src="profile.logoUrl || ''" alt="Logo" style="width: 640px; height: 260px;" />
      </div>
      <b-form-file v-model="file" accept="image/*" required browse-text="Durchsuchen" placeholder="Keine Datei gewählt"></b-form-file>
      <b-button @click="upload" >Hochladen</b-button>
    </b-card>
  </div>
</template>

<script>
import {uploadImage} from "@/storage/images";
import {mapState} from "vuex";

export default {
  data() {
    return {
      file: null
    }
  },
  props: ['value'],
  computed: mapState('user', ['user', 'profile']),
  methods: {
    async upload(){
      try {
        const url = await uploadImage(this.file, `public/${this.user.uid}`)
        this.$store.commit('user/setProfileUpdate', {'imageUrl': url})
        await this.$store.dispatch('user/saveProfile')
      } catch {
        this.$bvModal.show('error-modal')
      }
    }
  }
}
</script>